export default "<app-banner></app-banner>\n<app-menu-bar></app-menu-bar>\n"